// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b3ae8111","35":"66d83a21","167":"27bba91a","204":"b43abf95","211":"339978d1","385":"e3be5363","432":"e194b97f","526":"881fadc8","545":"bf735963","786":"b06e291f","809":"cee31da7","965":"390c7e65","984":"18a1bb12"}[chunkId] + ".chunk.js";
};